import { Route, Redirect } from "react-router-dom";

import useLocalStorage from "../hooks/useLocalStorage";

export default function AuthenticatedRoute({ component: Component, ...rest }) {
  const [authenticated, setAuthenticated] = useLocalStorage(
    "authenticated",
    false
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        return authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
}
